/* global moment, swal, _ */

import './style.less';
import AdminEmployeesModalCourseController from 'modals/employeesCourses';
import adminEmployeesModalCourseTemplate from 'modals/employeesCourses/index.html';
import AdminEmployeesModalTrackController from 'modals/employeesTracks';
import adminEmployeesModalTrackTemplate from 'modals/employeesTracks/index.html';
import AdminEmployeesComplianceModalReportController from 'modals/employeesComplianceReport';
import reportTemplate from 'modals/employeesComplianceReport/template.html';
import { get, keyBy, groupBy } from 'lodash';
import moment from 'moment';
import { deliveryMethods } from '@prolaera/library';

export default function(
  $q,
  $log,
  $filter,
  $state,
  $stateParams,
  $uibModal,
  ApiClass,
  ProfileClass,
  RegulatorClass,
  UserClass,
  Swal
) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  let teamCompliance, teamRegulators, profilesObj;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.profileUid = UserClass.profile_uid;
  vm.searchText = '';
  vm.useStatus = {};
  vm.useDepartment = {};
  vm.useLicense = {};
  let licenseArr = [];

  const deliveryMethodsDict = deliveryMethods.reduce((obj, { key, name }) => {
    obj[key] = name;
    return obj;
  }, {});

  vm.tableConfig = {
    isOpen: false,
    select: true,
    fixed_columns_count: 7,
    fixed_columns: {
      status: {
        active: true,
        text: 'Status',
        sort: 'status',
        style: 'min-width: 100px;'
      },
      lastName: {
        active: true,
        text: 'Last Name',
        sort: 'AdminEmployeesComplianceCtrl.getters.last',
        style: 'min-width: 100px;'
      },
      firstName: {
        active: true,
        text: 'First Name',
        sort: 'AdminEmployeesComplianceCtrl.getters.first',
        style: 'min-width: 100px;'
      },
      hireDate: {
        active: false,
        text: 'Hire Date',
        sort: 'AdminEmployeesComplianceCtrl.getters.hire_date',
        style: 'min-width: 100px;'
      },
      terminationDate: {
        active: false,
        text: 'Termination Date',
        sort: 'AdminEmployeesComplianceCtrl.getters.termination_date',
        style: 'min-width: 100px;'
      },
      license: {
        active: true,
        text: 'Licenses',
        sort: 'name',
        style: 'min-width: 400px;'
      },
      deadline: {
        active: true,
        text: 'Deadline',
        sort: 'sortDate',
        style: 'min-width: 200px;'
      },
      issueDate: {
        active: false,
        text: 'Issue Date',
        sort: 'sortDate',
        style: 'min-width: 200px;'
      },
      remaining: {
        active: true,
        text: 'Total Remaining',
        sort: 'AdminEmployeesComplianceCtrl.getters.remaining',
        style: 'min-width: 200px;'
      }
    },
    license_columns: {},
    selectAll: function(license) {
      for (const regulator in this.license_columns.all_headers) {
        const { reg_id } = this.license_columns.all_headers[regulator];
        if (reg_id === license) {
          this.license_columns.all_headers[regulator].active = !this.license_columns.all_headers[regulator].active; // keep ! for binding
        }
        if (!license) {
          this.license_columns.all_headers[regulator].active = !!this.select; // keep !! for binding
        }
      }

      for (const regulator in this.license_columns.all_columns) {
        const { reg_id } = this.license_columns.all_columns[regulator];
        if (reg_id === license) {
          this.license_columns.all_columns[regulator].active = !this.license_columns.all_columns[regulator].active; // keep ! for binding
        }
        if (!license) {
          this.license_columns.all_columns[regulator].active = !!this.select; // keep !! for binding
        }
      }

      if (license) return; // Exit early for license

      for (const column in this.fixed_columns) {
        this.fixed_columns[column].active = !!this.select; // keep !! for binding
      }

      this.select = !this.select;
      this.fixedColumnCountChange();
    },
    fixedColumnChange: function(column) {
      column.active = !column.active;

      this.fixedColumnCountChange();
    },
    fixedColumnCountChange: function() {
      let tempCount = 1; // start at 1 due to row select

      for (const column in this.fixed_columns) {
        if (this.fixed_columns[column].active) {
          tempCount++;
        }
      }

      this.fixed_columns_count = tempCount;
    }
  };

  vm.onFilter = function(stCtrl) {
    vm.filteredUsers = stCtrl.getFilteredCollection();
  };

  vm.onClickSelectAll = function(selectAll) {
    vm.filteredUsers.forEach(user => (user.selected = selectAll));
    vm.updateSelected();
  };

  vm.updateSelected = function() {
    vm.selectedEmployees = vm.filteredLicenses.filter(license => license.selected).filter(license => {
      const filteredRegulators = vm.userSearchFilters.regulators;

      if (!filteredRegulators.length || filteredRegulators.includes(license.reg_id)) {
        return true;
      }

      license.selected = false;

      return false;
    });
  };

  vm.assignCourse = function(selectedEmployees) {
    if (vm.selectedEmployees.length === 0) {
      return Swal.alert('Error', 'Please Select At Least One Employee', 'error');
    }
    $uibModal.open({
      backdrop: true,
      size: 'lg',
      template: adminEmployeesModalCourseTemplate,
      controller: AdminEmployeesModalCourseController,
      resolve: {
        selectedEmployees: function() {
          return selectedEmployees;
        }
      }
    });
  };

  vm.assignTrack = function(selectedEmployees) {
    if (vm.selectedEmployees.length === 0) {
      return Swal.alert('Error', 'Please Select At Least One Employee', 'error');
    }
    $uibModal.open({
      backdrop: true,
      size: 'lg',
      template: adminEmployeesModalTrackTemplate,
      controller: AdminEmployeesModalTrackController,
      resolve: {
        selectedEmployees: function() {
          return selectedEmployees;
        }
      }
    });
  };

  vm.emailComplianceReports = function() {
    if (vm.selectedEmployees.length === 0) {
      return Swal.alert('Error', 'Please Select At Least One Employee', 'error');
    }

    const compliancesDict = groupBy(vm.selectedEmployees, 'profile_uid');

    const compliances = Object.keys(compliancesDict).reduce((acc, profile_uid) => {
      const reg_ids = compliancesDict[profile_uid].reduce((acc_reg, { reg_id }) => {
        if (!acc_reg.includes(reg_id)) {
          acc_reg.push(reg_id);
        }

        return acc_reg;
      }, []);

      acc.push({ profile_uid, reg_ids });

      return acc;
    }, []);

    const plural = compliances.length > 1;
    const swalTitle = plural ? 'Send compliance reports?' : 'Send compliance report?';
    const swalContent = plural
      ? 'This will send compliance report emails to the selected users.'
      : 'This will send a compliance report email to the selected user.';

    return Swal.confirm(swalTitle, swalContent, 'info', 'Send')
      .then(() => {
        ApiClass.usersEmailsPost(
          {},
          { compliances, template: 'user_compliance_report' },
          { queryParams: { manage: true } }
        )
          .then(() => Swal.alert('Sending', 'Sending compliance reports', 'success'))
          .catch(error => {
            Swal.alert('Error', 'Sending compliance reports', 'error');
            throw error;
          });
      })
      .catch(error => {
        console.error(error);
        return;
      });
  };

  vm.selectedEmployeesReports = data => {
    const teamComplianceObj = {
      arr: [],
      obj: {}
    };

    for (let i = 0; i < data.length; i++) {
      const { profile_uid } = data[i];

      if (!teamComplianceObj.obj[profile_uid]) {
        teamComplianceObj.obj[profile_uid] = [];
      }
      teamComplianceObj.obj[profile_uid].push(data[i]);
      teamComplianceObj.arr.push(data[i]);
    }

    vm.generateReport(teamComplianceObj);
  };

  vm.pageSizeChanged = pageSize => {
    const search = {
      pageSize,
      page: 1
    };

    vm.setSearch(search);
  };

  vm.searchTextChanged = searchText => {
    const search = {
      searchText,
      page: 1
    };

    vm.setSearch(search);
  };

  vm.setSearch = search => {
    $state.go('.', { ...search, time: moment().valueOf() }, { notify: true, reload: false });

    vm.updateSelected();
  };

  vm.generateReport = data => {
    let modalCompliance = teamCompliance;

    if (data !== undefined) {
      modalCompliance = data;
    }

    $uibModal.open({
      backdrop: true,
      template: reportTemplate,
      controller: AdminEmployeesComplianceModalReportController,
      resolve: {
        compliance: () => modalCompliance,
        regulators: () => teamRegulators,
        filteredLicenses: () =>
          vm.userSearchFilters && vm.userSearchFilters.regulators ? vm.userSearchFilters.regulators : []
      }
    });
  };

  const categoryName = (category, subCategory = '', name = false) => {
    if (typeof category === 'number') {
      category = deliveryMethodsDict[category] || category;
    } else {
      category = $filter('CategoryName')(category);
    }

    return name || `${category}${subCategory}`;
  };

  function columnTemplate(name) {
    return {
      active: false,
      columns: {},
      colspan: 0,
      text: name
    };
  }

  function categoryTemplate(type, text, category, reg_id, year, colspan = 1, css) {
    const params = {
      active: false,
      annual: false,
      category,
      colspan,
      creditKey: `${reg_id}_${category}`,
      css,
      reg_id,
      sort: 'category',
      style: 'min-width: 125px',
      text,
      type,
      year
    };

    if (year) {
      params.annual = true;
      params.creditKey = `${reg_id}_${category}_annual-${year}`;
      params.text += ` - Year ${year}`;
    }

    return params;
  }

  function categoryHeaderTemplate(text, reg_id, colspan = 1) {
    return {
      active: false,
      colspan,
      reg_id,
      text
    };
  }

  function generateLicenseAnnuals(licenses) {
    licenses.forEach(license => {
      const { actual_annuals = {}, actual_annuals_incomplete = {}, cycle_limiter } = license;

      if (!cycle_limiter || !cycle_limiter.annual) return;

      Object.keys(actual_annuals)
        .sort()
        .forEach((lic_yr, index) => {
          license.actual_annuals[index + 1] = actual_annuals[lic_yr];
          license.actual_annuals_incomplete[index + 1] = actual_annuals_incomplete[lic_yr];
        });
    });

    return licenses;
  }

  function generateLicenseColumns(licenses, regulatorDict) {
    const licenseColumns = {};

    for (const license of licenses) {
      const { cyc_yr, name, reg_id, reg_date } = license;
      const { cycle_template, report, cycle, cycle_limiter } = regulatorDict[reg_id][reg_date];

      if (!licenseColumns[reg_id]) {
        licenseColumns[reg_id] = { all: columnTemplate(name) };
      }

      if (!licenseColumns[reg_id][cyc_yr]) {
        licenseColumns[reg_id][cyc_yr] = columnTemplate(name);
      }

      Object.keys(cycle_template)
        .sort()
        .forEach(category => {
          if (get(report, `categories.${category}.hide`, false)) {
            return;
          }
          const columnName = $filter('CategoryName')(`${category}`);

          if (!licenseColumns[reg_id][cyc_yr].columns[category]) {
            licenseColumns[reg_id][cyc_yr].colspan++;
            licenseColumns[reg_id][cyc_yr].columns[category] = categoryTemplate(
              'category',
              columnName,
              category,
              reg_id
            );
          }

          if (!licenseColumns[reg_id].all.columns[category]) {
            licenseColumns[reg_id].all.colspan++;
            licenseColumns[reg_id].all.columns[category] = categoryTemplate('category', columnName, category, reg_id);
          }
        });

      Object.keys(cycle_limiter.annual || {})
        .sort()
        .forEach(category => {
          if (get(report, `categories.${category}.hide`, false)) {
            return;
          }

          const columnName = $filter('CategoryName')(`${category}`);

          for (let i = 0; i < cycle; i++) {
            const column = `${category} - Year ${i + 1}`;
            const categoryKey = category === 'hours' ? 'total' : category;

            if (!licenseColumns[reg_id][cyc_yr].columns[column]) {
              licenseColumns[reg_id][cyc_yr].colspan++;
              licenseColumns[reg_id][cyc_yr].columns[column] = categoryTemplate(
                'annual',
                columnName,
                categoryKey,
                reg_id,
                i + 1
              );
            }

            if (!licenseColumns[reg_id].all.columns[column]) {
              licenseColumns[reg_id].all.colspan++;
              licenseColumns[reg_id].all.columns[column] = categoryTemplate(
                'annual',
                columnName,
                categoryKey,
                reg_id,
                i + 1
              );
            }
          }
        });

      Object.keys(cycle_limiter.span || {}).forEach(category => {
        if (get(report, `span.${category}.hide`, false)) {
          return;
        }

        const column = categoryName(category, ` - ${cycle_limiter.span[category].cycle} Years`);

        if (!licenseColumns[reg_id][cyc_yr].columns[column]) {
          licenseColumns[reg_id][cyc_yr].colspan++;
          licenseColumns[reg_id][cyc_yr].columns[column] = categoryTemplate('span', column, category, reg_id);
        }

        if (!licenseColumns[reg_id].all.columns[column]) {
          licenseColumns[reg_id].all.colspan++;
          licenseColumns[reg_id].all.columns[column] = categoryTemplate('span', column, category, reg_id);
        }
      });

      (cycle_limiter.span_count || []).forEach(({ name, key: category }) => {
        if (get(report, `span_count.${category}.hide`, false)) {
          return;
        }

        const column = name;

        if (!licenseColumns[reg_id][cyc_yr].columns[column]) {
          licenseColumns[reg_id][cyc_yr].colspan++;
          licenseColumns[reg_id][cyc_yr].columns[column] = categoryTemplate('span_count', name, category, reg_id);
        }

        if (!licenseColumns[reg_id].all.columns[column]) {
          licenseColumns[reg_id].all.colspan++;
          licenseColumns[reg_id].all.columns[column] = categoryTemplate('span_count', name, category, reg_id);
        }
      });
    }

    for (const regId in licenseColumns) {
      if (!vm.tableConfig.license_columns.all_headers) vm.tableConfig.license_columns.all_headers = [];
      if (!vm.tableConfig.license_columns.all_columns) vm.tableConfig.license_columns.all_columns = [];

      Object.keys(licenseColumns[regId].all.columns).forEach((column, index, array) => {
        let css = '';

        if (index == 0) {
          if (!css) css += 'border';
          css += '-left';
        }

        vm.tableConfig.license_columns.all_columns.push({
          ...licenseColumns[regId].all.columns[column],
          css,
          sort: 'category'
        });

        if (index === array.length - 1) {
          licenseColumns[licenseColumns[regId].all.columns[column].reg_id].all.colspan++;
          vm.tableConfig.license_columns.all_columns.push(
            categoryTemplate(
              'category',
              'Total Remaining',
              'total',
              licenseColumns[regId].all.columns[column].reg_id,
              undefined,
              undefined,
              'border-right'
            )
          );
        }
      });

      const { colspan, text } = licenseColumns[regId].all;
      vm.tableConfig.license_columns.all_headers.push(categoryHeaderTemplate(text, regId, colspan));
    }
  }

  function appendHumanReadableName(license, dictionary, type) {
    if (Array.isArray(license.profile[type])) {
      license.profile[`${type}Name`] = '';
      license.profile[type].forEach((id, i) => {
        if (dictionary[id] !== undefined && dictionary[id].name !== undefined) {
          license.profile[`${type}Name`] += dictionary[id].name;
        }

        if (i !== license.profile[type].length - 1) license.profile[`${type}Name`] += '; ';
      });
    } else {
      license.profile[`${type}Name`] = license.profile[type]
        ? dictionary[license.profile[type]]
          ? dictionary[license.profile[type]].name
          : ''
        : '';
    }
  }

  function activate() {
    const { rangeEnd, rangeStart, archived } = $stateParams;

    let latestLicensesOnly = true;

    if (rangeEnd || rangeStart) latestLicensesOnly = false;

    vm.loaded = false;
    vm.error = {};

    $q.all([
      RegulatorClass.loadRegulators(),
      ApiClass.scan(
        ApiClass.usersGet,
        {},
        {},
        {
          queryParams: {
            manage: true,
            'include:type': 'basic',
            'include:archived': archived,
            'scan:limit': 2000
          }
        }
      ),
      ApiClass.scan(
        ApiClass.usersLicensesGet,
        {},
        {},
        {
          queryParams: {
            'filter:latest': latestLicensesOnly,
            'filter:basic': true,
            'filter:rangeEnd': rangeEnd,
            'filter:rangeStart': rangeStart,
            'scan:limit': 2000,
            'include:archived': archived,
            manage: true
          }
        }
      ),
      ApiClass.companiesIdGet({ manage: true, id: company_id }, null, {
        queryParams: {
          locations: true,
          departments: true,
          practices: true,
          levels: true
        }
      })
    ])
      .then(
        ([
          regulators,
          { items: profiles },
          { items: compliance },
          {
            data: { departments, locations, practices, levels }
          }
        ]) => {
          const practiceDict = keyBy(practices, 'practice_id');
          const locationsDict = keyBy(locations, 'location_id');
          const levelDict = keyBy(levels, 'level_id');
          const deptDict = keyBy(departments, 'id');
          const regulatorDict = regulators.obj;
          compliance = generateLicenseAnnuals(compliance);
          teamCompliance = compliance;
          teamRegulators = regulators;
          vm.compliance = { arr: compliance };
          vm.regulators = regulators.arrCurrent;
          vm.regDict = regulators.objCurrent;
          profilesObj = _.keyBy(profiles, 'profile_uid');

          vm.getters = {
            department: val => {
              if (typeof val.profile.departmentName === 'object') return val.profile.departmentName.join();
              return val.profile.departmentName.toLowerCase();
            },
            first: val => val.profile.first,
            last: val => val.profile.last,
            termination_date: val => val.profile.termination_date,
            hire_date: val => val.profile.hire_date,
            remaining: val => {
              return get(val, 'applied_incomplete.total', 0);
            },
            categoryRemaining: (reg_id, category, type, year) => val => {
              if (val.reg_id !== reg_id) {
                return;
              }

              if (type === 'category') {
                return val.applied_incomplete[category];
              }

              if (type === 'annual') {
                return val.actual_annuals_incomplete[year] && val.actual_annuals_incomplete[year][category];
              }

              if (type === 'span') {
                return val.span[category].total_incomplete;
              }

              if (type === 'span_count') {
                return val.span_count[category].total_incomplete;
              }
            }
          };

          compliance.forEach(license => {
            // Checks for only latest licenses
            if (latestLicensesOnly && new Date(Date.now()) > new Date(license.cycle_date)) return;

            license.profile = profilesObj[license.profile_uid];
            if (license.profile === undefined) {
              return;
            }

            appendHumanReadableName(license, deptDict, 'department');
            appendHumanReadableName(license, practiceDict, 'practices');
            appendHumanReadableName(license, locationsDict, 'locations');
            appendHumanReadableName(license, levelDict, 'level');

            const cycle_total =
              license.cycle_limiter && 'cycle_total' in license.cycle_limiter
                ? license.cycle_limiter.cycle_total
                : regulatorDict[license.reg_id] &&
                  regulatorDict[license.reg_id][license.reg_date] &&
                  regulatorDict[license.reg_id][license.reg_date].cycle_total
                  ? regulatorDict[license.reg_id][license.reg_date].cycle_total
                  : 0;

            license.name = regulatorDict[license.reg_id].name;
            license.licenseProgress = $filter('Progress')(license.applied.total, cycle_total).toFixed(2);
            license.regTotal = cycle_total;
            license.cyc_time = moment(new Date(license.cycle_date), 'YYYY-MM-DD HH:mm').from();
            license.sortDate = new Date(license.cycle_date).getTime();
            licenseArr.push(license);
          });

          licenseArr.forEach(lic => {
            lic.remaining = lic.regTotal - lic.applied.total > 0 ? lic.regTotal - lic.applied.total : 0;
          });

          licenseArr = _.orderBy(licenseArr, ['status', 'sortDate', 'remaining'], ['asc', 'asc', 'desc']);

          vm.deptDict = deptDict;
          vm.departmentGroup = departments;
          vm.levelDict = levelDict;
          vm.levelGroup = levels;
          vm.locationDict = keyBy(locations, 'location_id');
          vm.locationGroup = locations;

          generateLicenseColumns(licenseArr, regulatorDict);

          vm.filteredLicenses = licenseArr;

          const { searchText, pageSize } = $stateParams;

          vm.totalItems = vm.filteredLicenses;
          vm.searchText = searchText || '';
          vm.itemsPerPage = pageSize;
          vm.dict = profilesObj;

          vm.loaded = true;
        }
      )
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: true, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/compliance/controller.js